import { render, staticRenderFns } from "./OperationMonitorPage.vue?vue&type=template&id=b65b7e7e&scoped=true"
import script from "./OperationMonitorPage.vue?vue&type=script&lang=ts"
export * from "./OperationMonitorPage.vue?vue&type=script&lang=ts"
import style0 from "./OperationMonitorPage.vue?vue&type=style&index=0&id=b65b7e7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65b7e7e",
  null
  
)

export default component.exports